const iconBlockAdapter = (data) => {
  return {
    text: data.text,
    title: data.title,
    icon: data.icon,
  };
};

export default ({ data }) => {
  return {
    items: data.items?.map(iconBlockAdapter),
  };
};
